// extracted by mini-css-extract-plugin
export default {"favoritesView":"favoritesView_mgYMU","contentContainer":"contentContainer_iR7GL","specialMessageContainer":"specialMessageContainer_LPlHr"};